import React, {useContext} from 'react';
import {Link, useLocation} from "react-router-dom";
import {SessionContext, SessionContextType} from "./components/SessionContext";
import Navigation from "./components/Navigation"
import Routes from "./Routes";
import Notifications from "./components/Notifications";
import Login from "./components/Login";
import SetPassword from "./components/SetPassword";
import Terms from "./components/legal/Terms";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import CookieNotice from "./components/CookieNotice";

/**
 * Ekrany, które ogląda ktoś niezalogowany. Rysują własny nagłówek z logo, więc pasek
 * nawigacji i stopka dołożyłyby drugie logo nad tym samym ekranem.
 */
const isPublicScreen = (pathname: string): boolean =>
    pathname === Login.url || pathname.startsWith(SetPassword.basePath);

const App = () => {

    const context: SessionContextType = useContext(SessionContext);
    const location = useLocation();

    if (isPublicScreen(location.pathname)) {
        return <>
            <Routes />
            <Notifications />
            <CookieNotice />
        </>;
    }

    return <>
        <header>
            <Navigation />
        </header>
        <div className="content">
            <Routes />
        </div>
        <footer>
            {!context.connected && <p className="no-connection pull-left">Brak połączenia z serwerem!</p>}
            <p className="legal-links pull-left">
                <Link to={Terms.url}>Regulamin</Link>
                <Link to={PrivacyPolicy.url}>Polityka prywatności</Link>
            </p>
            <p className="firm pull-right">{new Date().getFullYear()} Euroimpex SA</p>
        </footer>
        <Notifications />
        <CookieNotice />
    </>;
}

App.productName = 'GlobalService';

export default App;